"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _authContext = require("../authContext");
var _cookiesUtil = require("../cookiesUtil");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Auth = function Auth(_ref) {
  var children = _ref.children;
  var token = (0, _cookiesUtil.getCookie)("authToken");
  var userId = (0, _cookiesUtil.getCookie)("businessUserId");
  var onlineStoreId = (0, _cookiesUtil.getCookie)("onlineStoreId");
  var initialState = {
    authenticated: token && token !== "undefined" && userId && userId !== "undefined" ? true : false,
    user: {
      businessUserId: userId
    },
    authToken: token,
    onlineStoreId: onlineStoreId
  };
  var _useState = (0, _react.useState)(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  (0, _react.useEffect)(function () {
    // Update the document title using the browser API
    if (!initialState.authenticated) {
      setState(initialState);
    }
  }, [initialState.authenticated]);
  var initiateLogin = function initiateLogin() {};
  var parseJwt = function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  };
  var logout = function logout() {
    (0, _cookiesUtil.setCookie)("authToken", "", 0);
    (0, _cookiesUtil.setCookie)("businessUserId", "", 0);
    (0, _cookiesUtil.setCookie)("onlineStoreId", "", 0);
    (0, _cookiesUtil.setCookie)("businessUserName", "", 0);
    console.log(initialState);
    setSession(initialState);
    location.reload();
  };
  var handleAuthentication = function handleAuthentication(data) {
    setSession(data);
  };
  var setSession = function setSession(data) {
    var user = {
      businessUserId: data.id
    };
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        authenticated: true,
        authToken: data.token,
        organizationId: data.organizationId,
        user: user
      });
    });
    (0, _cookiesUtil.setCookie)("authToken", data.token, 1, data.token ? parseJwt(data.token).exp : '');
    (0, _cookiesUtil.setCookie)("businessUserId", data.id, 1);
  };
  var setUserRoles = function setUserRoles(data) {
    var user = _objectSpread({}, data);
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        user: user
      });
    });
    user && user.profile && user.profile.firstName && (0, _cookiesUtil.setCookie)("businessUserName", user.profile.firstName, 1);
  };
  var setApplication = function setApplication(id) {
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        application: id
      });
    });
  };
  var setStoreId = function setStoreId(id) {
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        onlineStoreId: id
      });
    });
    (0, _cookiesUtil.setCookie)("onlineStoreId", id, 1);
  };
  var authProviderValue = _objectSpread(_objectSpread({}, state), {}, {
    initiateLogin: initiateLogin,
    handleAuthentication: handleAuthentication,
    setUserRoles: setUserRoles,
    setApplication: setApplication,
    setStoreId: setStoreId,
    logout: logout
  });
  return /*#__PURE__*/_react["default"].createElement(_authContext.AuthProvider, {
    value: authProviderValue
  }, children);
};
var _default = Auth;
exports["default"] = _default;